import { environment } from 'src/environments/environment';
import { I18nService } from './i18n.service';
import { Translations } from 'src/i18n';
import { I18nServiceConfig } from './models-external';

export function i18nServiceFactory(overrides: Partial<I18nServiceConfig> = {}) {
  const service = new I18nService();

  service.initialise({
    initialLang: "en"                                                                                                                   ,
    debug: !environment.production,
    resources: {
      en: { translation: Translations.en },
      pl: { translation: Translations.pl },
      cs: { translation: Translations.cs },
    },
    ...overrides,
  });

  return service;
}

export function provideI18nService() {
  return { provide: I18nService, useFactory: i18nServiceFactory };
}
